import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { inputCls } from "../site/formPrimitives";
import { Plus, Pencil, Trash2, X, Save } from "lucide-react";

const ICONS = ["smartphone", "battery-charging", "plug-zap", "camera", "layers", "droplets", "laptop", "tablet", "wrench", "cpu", "hard-drive", "shield"];
const blank = { title: "", description: "", icon: "wrench", order: 0 };

export default function ServicesAdmin() {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);

  const load = () => api.get("/content/services").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!edit.title.trim()) { toast.error("Tittel kreves"); return; }
    if (edit.id) await api.put(`/admin/services/${edit.id}`, edit);
    else await api.post("/admin/services", edit);
    toast.success("Lagret"); setEdit(null); load();
  };
  const remove = async (id) => {
    if (!window.confirm("Slette tjenesten?")) return;
    await api.delete(`/admin/services/${id}`); toast.success("Slettet"); load();
  };

  return (
    <div data-testid="admin-services">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-bold text-navy">Tjenester</h1>
          <p className="mt-1 text-sm text-ink/60">Rediger tjenestene som vises på nettstedet.</p>
        </div>
        <button onClick={() => setEdit({ ...blank, order: rows.length + 1 })} className="inline-flex items-center gap-2 rounded-full bg-navy px-5 py-2.5 text-sm font-semibold text-white hover:bg-navy-800" data-testid="service-add"><Plus className="h-4 w-4" /> Legg til</button>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {rows.map((s) => (
          <div key={s.id} className="rounded-xl border border-hairline bg-white p-5 shadow-sm" data-testid={`service-item-${s.id}`}>
            <div className="flex items-start justify-between">
              <div>
                <p className="font-heading text-lg font-bold text-navy">{s.title}</p>
                <p className="mt-1 text-sm text-ink/60">{s.description}</p>
                <span className="mt-2 inline-block rounded bg-slate-100 px-2 py-0.5 text-xs text-ink/50">{s.icon}</span>
              </div>
              <div className="flex gap-1">
                <button onClick={() => setEdit(s)} className="p-2 text-ink/50 hover:text-electric" data-testid="service-edit"><Pencil className="h-4 w-4" /></button>
                <button onClick={() => remove(s.id)} className="p-2 text-ink/50 hover:text-red-600" data-testid="service-delete"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {edit && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-navy/60" onClick={() => setEdit(null)} />
          <div className="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading text-xl font-bold text-navy">{edit.id ? "Rediger" : "Ny"} tjeneste</h3>
              <button onClick={() => setEdit(null)}><X className="h-5 w-5 text-ink/50" /></button>
            </div>
            <div className="space-y-3">
              <input className={inputCls} placeholder="Tittel" value={edit.title} onChange={(e) => setEdit({ ...edit, title: e.target.value })} data-testid="service-title-input" />
              <textarea rows={3} className={`${inputCls} resize-none`} placeholder="Beskrivelse" value={edit.description} onChange={(e) => setEdit({ ...edit, description: e.target.value })} data-testid="service-desc-input" />
              <select className={inputCls} value={edit.icon} onChange={(e) => setEdit({ ...edit, icon: e.target.value })} data-testid="service-icon-input">
                {ICONS.map((i) => <option key={i} value={i}>{i}</option>)}
              </select>
              <input type="number" className={inputCls} placeholder="Rekkefølge" value={edit.order} onChange={(e) => setEdit({ ...edit, order: Number(e.target.value) })} />
            </div>
            <button onClick={save} className="mt-5 w-full inline-flex items-center justify-center gap-2 rounded-full bg-warm px-5 py-3 text-sm font-semibold text-navy hover:bg-warm-dark" data-testid="service-save"><Save className="h-4 w-4" /> Lagre</button>
          </div>
        </div>
      )}
    </div>
  );
}
